/* sections/section-shop-grid — tab switcher with fade animation + JS sort
   Pure DOM operations, no AJAX. */

(function () {
  'use strict';

  function getActivePanel(panels) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].classList.contains('is-active')) return panels[i];
    }
    return null;
  }

  function panelCount(panel) {
    if (!panel) return 0;
    var all = panel.querySelectorAll('.shop-grid__product-item');
    var visible = 0;
    for (var i = 0; i < all.length; i++) {
      if (all[i].dataset.filterHidden !== 'true') visible++;
    }
    if (visible === 0 && panel.dataset.panelCount && panel.dataset.panelCount !== '0' && !panel.dataset.filterApplied) {
      return parseInt(panel.dataset.panelCount, 10) || 0;
    }
    return visible;
  }

  function getActiveFilterForm() {
    var panel = document.querySelector('[data-shop-grid-filter-panel].is-active');
    return panel ? panel.querySelector('.shop-grid__filter-form') : null;
  }

  function getActiveFilters(form) {
    var filters = {};
    if (!form) return filters;
    var inputs = form.querySelectorAll('input[name], select[name]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var name = input.name;
      if (!name) continue;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (!input.checked) continue;
      }
      var val = input.value;
      if (val === '' || val == null) continue;
      if (!filters[name]) filters[name] = [];
      filters[name].push(val);
    }
    return filters;
  }

  function itemMatchesFilters(item, filters) {
    for (var key in filters) {
      if (!Object.prototype.hasOwnProperty.call(filters, key)) continue;
      var values = filters[key];
      if (!values.length) continue;
      if (key === 'filter.p.vendor') {
        var vendor = (item.dataset.vendor || '').toLowerCase();
        var match = false;
        for (var i = 0; i < values.length; i++) {
          if (vendor === values[i].toLowerCase().replace(/\s+/g, '-')) { match = true; break; }
        }
        if (!match) return false;
      } else if (key === 'filter.p.product_type') {
        var type = (item.dataset.productType || '').toLowerCase();
        var matchT = false;
        for (var j = 0; j < values.length; j++) {
          if (type === values[j].toLowerCase().replace(/\s+/g, '-')) { matchT = true; break; }
        }
        if (!matchT) return false;
      } else if (key === 'filter.p.tag' || key.indexOf('filter.p.tag') === 0) {
        var tags = (item.dataset.tags || '').split('|');
        var matchG = false;
        for (var k = 0; k < values.length; k++) {
          var v = values[k].toLowerCase();
          if (tags.indexOf(v) !== -1) { matchG = true; break; }
        }
        if (!matchG) return false;
      } else if (key.indexOf('filter.v.option.') === 0) {
        var optName = key.substring('filter.v.option.'.length).toLowerCase();
        var optStr = (item.dataset.options || '').toLowerCase();
        var matchO = false;
        for (var m = 0; m < values.length; m++) {
          var needle = optName + '=' + values[m].toLowerCase().replace(/\s+/g, '-');
          if (optStr.indexOf(needle + '|') !== -1 || optStr.indexOf(needle) === optStr.length - needle.length) {
            matchO = true; break;
          }
        }
        if (!matchO) return false;
      } else if (key === 'filter.v.price.gte') {
        var priceG = parseFloat(item.dataset.price) || 0;
        if (priceG < parseFloat(values[0])) return false;
      } else if (key === 'filter.v.price.lte') {
        var priceL = parseFloat(item.dataset.price) || 0;
        if (priceL > parseFloat(values[0])) return false;
      } else if (key === 'filter.v.availability') {
        var avail = item.dataset.available === 'true';
        if (values[0] === '1' && !avail) return false;
        if (values[0] === '0' && avail) return false;
      } else if (key.indexOf('filter.p.m.') === 0) {
        var metaStr = (item.dataset.tags || '').toLowerCase();
        var matchM = false;
        for (var n = 0; n < values.length; n++) {
          if (metaStr.indexOf(values[n].toLowerCase()) !== -1) { matchM = true; break; }
        }
        if (!matchM) return false;
      }
    }
    return true;
  }

  function collectAvailableValues(panel) {
    var values = {
      vendor: new Set(),
      product_type: new Set(),
      tag: new Set(),
      option: {},
      price_min: Infinity,
      price_max: -Infinity,
      has_available: false,
      has_unavailable: false
    };
    if (!panel) return values;
    var items = panel.querySelectorAll('.shop-grid__product-item');
    items.forEach(function (item) {
      var vendor = (item.dataset.vendor || '').toLowerCase();
      if (vendor) values.vendor.add(vendor);
      var ptype = (item.dataset.productType || '').toLowerCase();
      if (ptype) values.product_type.add(ptype);
      var tags = (item.dataset.tags || '').split('|');
      tags.forEach(function (t) { if (t) values.tag.add(t.toLowerCase()); });
      var opts = (item.dataset.options || '').split('|');
      opts.forEach(function (pair) {
        if (!pair) return;
        var eq = pair.indexOf('=');
        if (eq < 0) return;
        var name = pair.substring(0, eq).toLowerCase();
        var val = pair.substring(eq + 1).toLowerCase();
        if (!values.option[name]) values.option[name] = new Set();
        values.option[name].add(val);
      });
      var price = parseFloat(item.dataset.price);
      if (!isNaN(price)) {
        if (price < values.price_min) values.price_min = price;
        if (price > values.price_max) values.price_max = price;
      }
      if (item.dataset.available === 'true') values.has_available = true;
      else values.has_unavailable = true;
    });
    return values;
  }

  function pruneFilterPanel(filterPanel, available) {
    if (!filterPanel) return;
    var inputs = filterPanel.querySelectorAll('input[name]');
    var groupVisibility = {};
    inputs.forEach(function (input) {
      var name = input.name;
      var rawVal = input.value || '';
      var val = rawVal.toLowerCase().replace(/\s+/g, '-');
      var keep = true;
      if (name === 'filter.p.vendor') {
        keep = available.vendor.has(val) || available.vendor.has(rawVal.toLowerCase());
      } else if (name === 'filter.p.product_type') {
        keep = available.product_type.has(val) || available.product_type.has(rawVal.toLowerCase());
      } else if (name === 'filter.p.tag' || name.indexOf('filter.p.tag') === 0) {
        keep = available.tag.has(rawVal.toLowerCase());
      } else if (name.indexOf('filter.v.option.') === 0) {
        var optName = name.substring('filter.v.option.'.length).toLowerCase();
        var bucket = available.option[optName];
        keep = !!(bucket && (bucket.has(val) || bucket.has(rawVal.toLowerCase())));
      } else if (name === 'filter.v.availability') {
        if (rawVal === '1') keep = available.has_available;
        else if (rawVal === '0') keep = available.has_unavailable;
      } else if (name === 'filter.v.price.gte' || name === 'filter.v.price.lte') {
        keep = available.price_min !== Infinity;
      }
      var li = input.closest('.collection__filter-tag, .collection__filter-tag--swatch, li');
      if (li) {
        if (keep) {
          li.removeAttribute('data-filter-empty');
          li.style.display = '';
        } else {
          li.setAttribute('data-filter-empty', 'true');
          li.style.display = 'none';
        }
      }
      if (!groupVisibility[name]) groupVisibility[name] = false;
      if (keep) groupVisibility[name] = true;
    });
    // Hide whole filter group if every option pruned
    var groups = filterPanel.querySelectorAll('.collection__filter, [data-collapsible-single]');
    groups.forEach(function (g) {
      var groupInputs = g.querySelectorAll('input[name]');
      if (!groupInputs.length) return;
      var anyVisible = false;
      groupInputs.forEach(function (inp) {
        var li = inp.closest('.collection__filter-tag, .collection__filter-tag--swatch, li');
        if (!li || li.getAttribute('data-filter-empty') !== 'true') anyVisible = true;
      });
      if (anyVisible) {
        g.removeAttribute('data-filter-empty');
        g.style.display = '';
      } else {
        g.setAttribute('data-filter-empty', 'true');
        g.style.display = 'none';
      }
    });

    // Auto-expand "Show more" when all always-visible items are pruned but the show-more list has items
    var showMoreContainers = filterPanel.querySelectorAll('[data-show-more-container]');
    showMoreContainers.forEach(function (container) {
      var actions = container.closest('[data-show-more-actions]');
      var parentList = actions ? actions.parentElement : null;
      if (!parentList) return;
      // Count visible items that are NOT inside the show-more container (siblings of the actions <li>)
      var siblings = parentList.children;
      var visibleAlways = 0;
      for (var i = 0; i < siblings.length; i++) {
        var sib = siblings[i];
        if (sib === actions) continue;
        if (sib.matches('.collection__filter-tag, .collection__filter-tag--swatch')) {
          if (sib.getAttribute('data-filter-empty') !== 'true') visibleAlways++;
        }
      }
      // Count visible items inside the show-more container
      var hiddenItems = container.querySelectorAll('.collection__filter-tag, .collection__filter-tag--swatch');
      var visibleInHidden = 0;
      hiddenItems.forEach(function (it) {
        if (it.getAttribute('data-filter-empty') !== 'true') visibleInHidden++;
      });
      var trigger = actions.querySelector('[data-show-more-trigger]');
      if (visibleAlways === 0 && visibleInHidden > 0) {
        // Only hidden items remain → auto-expand and hide the toggle
        container.classList.add('is-expanded');
        if (trigger) {
          trigger.classList.add('is-expanded');
          trigger.setAttribute('aria-expanded', 'true');
          trigger.style.display = 'none';
        }
        actions.style.display = '';
      } else if (visibleInHidden === 0) {
        // Nothing in show-more bucket → hide the toggle entirely
        if (trigger) trigger.style.display = 'none';
        actions.style.display = 'none';
      } else {
        if (trigger) trigger.style.display = '';
        actions.style.display = '';
      }
    });
  }

  function hideSwatchesWithoutColor(filterPanel) {
    // Detect swatches whose --swatch CSS var doesn't resolve to a real color
    var swatches = filterPanel.querySelectorAll('.collection__filter-tag--swatch');
    swatches.forEach(function (li) {
      var label = li.querySelector('.swatch__label');
      if (!label) return;
      var swatchValue = label.style.getPropertyValue('--swatch') || '';
      swatchValue = swatchValue.trim();
      if (!swatchValue) {
        li.style.display = 'none';
        li.setAttribute('data-filter-empty', 'true');
        return;
      }
      // Test if the var() reference resolves to an actual color
      var test = document.createElement('span');
      test.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;background-color:' + swatchValue + ';';
      label.appendChild(test);
      var resolved = getComputedStyle(test).backgroundColor;
      label.removeChild(test);
      // rgba(0, 0, 0, 0) = transparent = unresolved var
      if (!resolved || resolved === 'rgba(0, 0, 0, 0)' || resolved === 'transparent') {
        li.style.display = 'none';
        li.setAttribute('data-filter-empty', 'true');
      }
    });
  }

  function redistributeFilterItems(filterPanel, threshold) {
    // After pruning, place first `threshold` visible items always-visible, rest into show-more container
    threshold = threshold || 4;
    var groups = filterPanel.querySelectorAll('.collection__filter, [data-collapsible-single]');
    groups.forEach(function (g) {
      var showMoreAction = g.querySelector('[data-show-more-actions]');
      var showMoreContainer = g.querySelector('[data-show-more-container]');
      if (!showMoreAction || !showMoreContainer) return;
      var innerList = showMoreContainer.querySelector('ul');
      var outerList = showMoreAction.parentElement;
      if (!innerList || !outerList) return;

      var allItems = Array.prototype.slice.call(g.querySelectorAll('.collection__filter-tag, .collection__filter-tag--swatch'));
      var visibleItems = allItems.filter(function (it) {
        return it.getAttribute('data-filter-empty') !== 'true' && it.style.display !== 'none';
      });

      // Re-insert into correct buckets in stable order
      visibleItems.forEach(function (item, idx) {
        if (idx < threshold) {
          outerList.insertBefore(item, showMoreAction);
        } else {
          innerList.appendChild(item);
        }
      });

      var trigger = showMoreAction.querySelector('[data-show-more-trigger]');
      if (visibleItems.length > threshold) {
        showMoreAction.style.display = '';
        if (trigger) {
          trigger.style.display = '';
          // Reset to collapsed state
          trigger.classList.remove('is-expanded');
          trigger.setAttribute('aria-expanded', 'false');
        }
        showMoreContainer.classList.remove('is-expanded');
      } else {
        showMoreAction.style.display = 'none';
        if (trigger) trigger.style.display = 'none';
      }
    });
  }

  function pruneForActiveTab(sidebar, panels) {
    if (!sidebar) return;
    var activePanel = getActivePanel(panels);
    var activeFilterPanel = sidebar.querySelector('[data-shop-grid-filter-panel].is-active');
    if (!activePanel || !activeFilterPanel) return;
    var available = collectAvailableValues(activePanel);
    pruneFilterPanel(activeFilterPanel, available);
    // Also hide swatches that have an undefined --swatch CSS variable
    hideSwatchesWithoutColor(activeFilterPanel);
    // Redistribute: first 4 always visible, rest behind "Show more"
    redistributeFilterItems(activeFilterPanel, 4);
  }

  function applyFiltersToActivePanel(panels, countEl, sortEl) {
    var form = getActiveFilterForm();
    var filters = getActiveFilters(form);
    var activePanel = getActivePanel(panels);
    if (!activePanel) return;
    var items = activePanel.querySelectorAll('.shop-grid__product-item');
    items.forEach(function (item) {
      if (itemMatchesFilters(item, filters)) {
        item.dataset.filterHidden = 'false';
      } else {
        item.dataset.filterHidden = 'true';
      }
    });
    activePanel.dataset.filterApplied = 'true';
    if (sortEl && sortEl.value) sortPanel(activePanel, sortEl.value);
    paginatePanel(activePanel, 1);
    updateCount(countEl, activePanel);
  }

  function updateCount(countEl, panel) {
    if (!countEl || !panel) return;
    var n = panelCount(panel);
    countEl.textContent = n + ' product' + (n === 1 ? '' : 's');
  }

  function sortPanel(panel, sortKey) {
    if (!panel) return;
    var grid = panel.querySelector('.shop-grid__products');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.shop-grid__product-item'));
    if (!items.length) return;

    var comparator;
    switch (sortKey) {
      case 'title-ascending':
        comparator = function (a, b) {
          return (a.dataset.sortTitle || '').localeCompare(b.dataset.sortTitle || '');
        };
        break;
      case 'title-descending':
        comparator = function (a, b) {
          return (b.dataset.sortTitle || '').localeCompare(a.dataset.sortTitle || '');
        };
        break;
      case 'price-ascending':
        comparator = function (a, b) {
          return (parseFloat(a.dataset.sortPrice) || 0) - (parseFloat(b.dataset.sortPrice) || 0);
        };
        break;
      case 'price-descending':
        comparator = function (a, b) {
          return (parseFloat(b.dataset.sortPrice) || 0) - (parseFloat(a.dataset.sortPrice) || 0);
        };
        break;
      case 'created-ascending':
        comparator = function (a, b) {
          return (parseInt(a.dataset.sortCreated, 10) || 0) - (parseInt(b.dataset.sortCreated, 10) || 0);
        };
        break;
      case 'created-descending':
        comparator = function (a, b) {
          return (parseInt(b.dataset.sortCreated, 10) || 0) - (parseInt(a.dataset.sortCreated, 10) || 0);
        };
        break;
      case 'featured':
      default:
        comparator = function (a, b) {
          return (parseInt(a.dataset.sortFeatured, 10) || 0) - (parseInt(b.dataset.sortFeatured, 10) || 0);
        };
        break;
    }

    items.sort(comparator);

    // Re-append in sorted order. DocumentFragment for fewer reflows.
    var frag = document.createDocumentFragment();
    items.forEach(function (item, idx) {
      if (item.dataset.aosDelay !== undefined) {
        item.dataset.aosDelay = String(idx * 40);
      }
      frag.appendChild(item);
    });
    grid.appendChild(frag);

    // Re-trigger any AOS animations
    triggerAosOn(grid);
  }

  var NEXT_SVG = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0.984271 14C0.789605 14 0.599306 13.9424 0.437442 13.8345C0.275578 13.7266 0.14942 13.5732 0.0749222 13.3937C0.000424565 13.2142 -0.019066 13.0167 0.0189155 12.8262C0.0568969 12.6357 0.150644 12.4607 0.288301 12.3233L5.62379 6.99881L0.288301 1.67433C0.104785 1.48991 0.00199659 1.24041 0.00245231 0.980507C0.00290803 0.720601 0.106571 0.471469 0.290733 0.287687C0.474895 0.103905 0.724541 0.000456284 0.984985 1.50578e-06C1.24543 -0.000453272 1.49544 0.102123 1.68024 0.285261L7.7117 6.30428C7.8031 6.39548 7.87561 6.50376 7.92507 6.62293C7.97454 6.7421 8 6.86982 8 6.99881C8 7.1278 7.97454 7.25553 7.92507 7.37469C7.87561 7.49386 7.8031 7.60214 7.7117 7.69335L1.68024 13.7124C1.58894 13.8037 1.48046 13.8761 1.36102 13.9255C1.24158 13.9749 1.11355 14.0002 0.984271 14Z" fill="currentColor"/></svg>';

  function buildPageList(current, total) {
    // Always show: 1, current-1, current, current+1, total
    // Ellipsis between non-adjacent pages
    if (total <= 7) {
      var all = [];
      for (var i = 1; i <= total; i++) all.push(i);
      return all;
    }
    var pages = new Set([1, total, current]);
    if (current - 1 > 1) pages.add(current - 1);
    if (current + 1 < total) pages.add(current + 1);
    var sorted = Array.from(pages).sort(function (a, b) { return a - b; });
    var out = [];
    for (var i = 0; i < sorted.length; i++) {
      out.push(sorted[i]);
      if (i < sorted.length - 1 && sorted[i + 1] - sorted[i] > 1) out.push('…');
    }
    return out;
  }

  function paginatePanel(panel, page) {
    if (!panel) return;
    var grid = panel.querySelector('.shop-grid__products');
    var nav = panel.querySelector('[data-shop-grid-pagination]');
    if (!grid || !nav) return;
    var allItems = Array.prototype.slice.call(grid.querySelectorAll('.shop-grid__product-item'));
    var items = allItems.filter(function (it) { return it.dataset.filterHidden !== 'true'; });
    var pageSize = parseInt(panel.dataset.pageSize, 10) || 12;
    var totalPages = Math.max(1, Math.ceil(items.length / pageSize));
    var current = Math.min(Math.max(parseInt(page, 10) || 1, 1), totalPages);
    panel.dataset.currentPage = String(current);

    var start = (current - 1) * pageSize;
    var end = start + pageSize;
    allItems.forEach(function (item) {
      if (item.dataset.filterHidden === 'true') { item.hidden = true; return; }
      var idx = items.indexOf(item);
      if (idx >= start && idx < end) {
        item.hidden = false;
        if (item.dataset.aos) item.classList.remove('aos-animate');
      } else {
        item.hidden = true;
      }
    });

    if (totalPages <= 1) {
      nav.hidden = true;
      nav.innerHTML = '';
      return;
    }
    nav.hidden = false;

    var pages = buildPageList(current, totalPages);
    var html = '';
    pages.forEach(function (p) {
      if (p === '…') {
        html += '<span class="shop-grid__pagination-ellipsis" aria-hidden="true">...</span>';
      } else {
        var isCurrent = p === current;
        html += '<button type="button" class="shop-grid__pagination-page' + (isCurrent ? ' is-current' : '') + '" data-page="' + p + '"' + (isCurrent ? ' aria-current="page"' : '') + '>' + p + '</button>';
      }
    });
    var nextDisabled = current >= totalPages;
    html += '<button type="button" class="shop-grid__pagination-next" data-page="' + (current + 1) + '" aria-label="Next page"' + (nextDisabled ? ' disabled' : '') + '>' + NEXT_SVG + '</button>';
    nav.innerHTML = html;

    // Re-fire reveal animations on the now-visible items
    requestAnimationFrame(function () { triggerAosOn(grid); });
  }

  function bindPagination(panel) {
    var nav = panel.querySelector('[data-shop-grid-pagination]');
    if (!nav || nav.dataset.bound === 'true') return;
    nav.dataset.bound = 'true';
    nav.addEventListener('click', function (e) {
      var target = e.target.closest('[data-page]');
      if (!target || target.disabled) return;
      var page = parseInt(target.dataset.page, 10);
      paginatePanel(panel, page);
      // Scroll into view of the products area for context
      var grid = panel.querySelector('.shop-grid__products');
      if (grid) {
        var top = grid.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  function triggerAosOn(scope) {
    var items = scope.querySelectorAll('[data-aos]');
    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      items.forEach(function (el) { el.classList.remove('aos-animate'); });
      window.AOS.refreshHard();
      return;
    }
    if (window.AOS && typeof window.AOS.refresh === 'function') {
      window.AOS.refresh();
      return;
    }
    items.forEach(function (el) { el.classList.remove('aos-animate'); });
    requestAnimationFrame(function () {
      items.forEach(function (el, idx) {
        setTimeout(function () { el.classList.add('aos-animate'); }, idx * 40);
      });
    });
  }

  function initTabSlider(root) {
    var wrap = root.querySelector('[data-shop-grid-tabs-wrap]');
    var tabs = root.querySelector('[data-shop-grid-tabs]');
    if (!wrap || !tabs) return;

    var prevBtn = wrap.querySelector('[data-shop-grid-tabs-prev]');
    var nextBtn = wrap.querySelector('[data-shop-grid-tabs-next]');
    var dragEnabled = wrap.dataset.enableDrag === 'true';
    var loop = wrap.dataset.loop === 'true';

    function isSliderMode() {
      var isDesktop = window.matchMedia('(min-width: 768px)').matches;
      return isDesktop
        ? wrap.classList.contains('shop-grid__tabs-wrap--slider-desktop')
        : wrap.classList.contains('shop-grid__tabs-wrap--slider-mobile');
    }

    function scrollStep() {
      var first = tabs.querySelector('.shop-grid__tab');
      if (!first) return tabs.clientWidth;
      var style = getComputedStyle(tabs);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      if (!isSliderMode()) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      if (loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      prevBtn.disabled = tabs.scrollLeft <= 1;
      nextBtn.disabled = tabs.scrollLeft >= maxScroll - 1;
    }

    function scrollBy(delta) {
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      var target = tabs.scrollLeft + delta;
      if (loop) {
        if (target < 0) target = maxScroll;
        else if (target > maxScroll) target = 0;
      }
      tabs.scrollTo({ left: target, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-scrollStep()); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(scrollStep()); });
    tabs.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    // Pointer drag — rewritten:
    //   1. A real drag only begins once the pointer has moved past DRAG_THRESHOLD,
    //      so quick taps on a tab always pass through as clicks.
    //   2. scroll-behavior is forced to 'auto' inline the instant a drag starts,
    //      so the very first scrollLeft assignment is not smoothed by CSS (no jerk).
    //   3. setPointerCapture is called only when a drag actually starts.
    //   4. On release, the pending click is intercepted at the capture phase and
    //      cancelled, so a tap that moved a few pixels still navigates the tab.
    if (dragEnabled) {
      var DRAG_THRESHOLD = 8;
      var drag = null;
      var momentumRAF = null;

      function stopMomentum() {
        if (momentumRAF) {
          cancelAnimationFrame(momentumRAF);
          momentumRAF = null;
        }
      }

      // Restore scroll-behavior + CSS scroll-snap once the gesture has settled.
      function restoreAfterDrag() {
        tabs.style.scrollBehavior = '';
        tabs.style.scrollSnapType = '';
        updateArrows();
      }

      // Gently align to the nearest tab, then re-enable CSS snap afterwards so
      // it can't fight the animation or cause a jump.
      function snapToNearest() {
        var step = scrollStep();
        var maxScroll = tabs.scrollWidth - tabs.clientWidth;
        if (step > 0) {
          var target = Math.round(tabs.scrollLeft / step) * step;
          if (target < 0) target = 0;
          if (target > maxScroll) target = maxScroll;
          tabs.scrollTo({ left: target, behavior: 'smooth' });
        }
        setTimeout(restoreAfterDrag, 360);
      }

      // Inertial glide after the finger/mouse lifts.
      function startMomentum(v0) {
        var v = v0;
        var maxScroll = tabs.scrollWidth - tabs.clientWidth;
        function frame() {
          v *= 0.92;
          var next = tabs.scrollLeft + v;
          if (next <= 0) { tabs.scrollLeft = 0; momentumRAF = null; restoreAfterDrag(); return; }
          if (next >= maxScroll) { tabs.scrollLeft = maxScroll; momentumRAF = null; restoreAfterDrag(); return; }
          tabs.scrollLeft = next;
          if (Math.abs(v) < 0.5) { momentumRAF = null; snapToNearest(); return; }
          momentumRAF = requestAnimationFrame(frame);
        }
        momentumRAF = requestAnimationFrame(frame);
      }

      var onPointerDown = function (e) {
        if (!isSliderMode()) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        stopMomentum();
        drag = {
          id: e.pointerId,
          startX: e.clientX,
          startScroll: tabs.scrollLeft,
          lastX: e.clientX,
          lastT: e.timeStamp || performance.now(),
          velocity: 0,
          dragging: false,
          captured: false
        };
      };

      var onPointerMove = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.startX;
        if (!drag.dragging) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          drag.dragging = true;
          tabs.style.scrollBehavior = 'auto';
          tabs.style.scrollSnapType = 'none';
          tabs.classList.add('is-dragging');
          try {
            tabs.setPointerCapture(e.pointerId);
            drag.captured = true;
          } catch (_) {}
        }
        var now = e.timeStamp || performance.now();
        var dt = now - drag.lastT;
        if (dt > 0) {
          // px the scroll travels per ms (scroll moves opposite the pointer)
          drag.velocity = (drag.lastX - e.clientX) / dt;
        }
        drag.lastX = e.clientX;
        drag.lastT = now;
        tabs.scrollLeft = drag.startScroll - dx;
      };

      var onPointerEnd = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var wasDragging = drag.dragging;
        var wasCaptured = drag.captured;
        var pid = drag.id;
        var now = e.timeStamp || performance.now();
        var idle = now - drag.lastT;
        // If the pointer was held still before release, don't fling.
        var velocity = idle > 80 ? 0 : drag.velocity;
        drag = null;

        if (wasCaptured) {
          try { tabs.releasePointerCapture(pid); } catch (_) {}
        }
        tabs.classList.remove('is-dragging');

        if (wasDragging) {
          // Swallow the click that fires at the tail of a drag.
          var blockClick = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
          };
          tabs.addEventListener('click', blockClick, true);
          setTimeout(function () {
            tabs.removeEventListener('click', blockClick, true);
          }, 0);

          var v0 = velocity * 16; // px for the first inertia frame (~60fps)
          if (Math.abs(v0) > 1) {
            startMomentum(v0);
          } else {
            snapToNearest();
          }
        } else {
          restoreAfterDrag();
        }
      };

      tabs.addEventListener('pointerdown', onPointerDown);
      tabs.addEventListener('pointermove', onPointerMove);
      tabs.addEventListener('pointerup', onPointerEnd);
      tabs.addEventListener('pointercancel', onPointerEnd);
    }

    // After fonts/images load, recalc arrow state
    requestAnimationFrame(updateArrows);
    setTimeout(updateArrows, 200);
  }

  function initShopGrid(root) {
    if (!root || root.dataset.shopGridReady === 'true') return;
    root.dataset.shopGridReady = 'true';

    initTabSlider(root);

    var tabBar = root.querySelector('[data-shop-grid-tabs]');
    var panelsContainer = root.querySelector('[data-shop-grid-panels]');
    var sidebar = root.querySelector('[data-shop-grid-sidebar]');
    var countEl = root.querySelector('[data-shop-grid-count]');
    var sortEl = root.querySelector('[data-shop-grid-sort]');
    if (!tabBar || !panelsContainer) return;

    var filterPanels = sidebar ? Array.prototype.slice.call(sidebar.querySelectorAll('[data-shop-grid-filter-panel]')) : [];

    // The filter snippet emits the same input IDs in every panel (filter-<Label>-<index>).
    // Browsers resolve <label for="..."> to the FIRST id in the DOM, so clicks in
    // non-first panels would toggle the wrong (hidden) input. Suffix each panel's
    // IDs / fors / aria-controls so every panel is self-contained.
    filterPanels.forEach(function (panel, panelIdx) {
      if (panelIdx === 0) return; // first panel already has the canonical IDs; keep as-is
      var suffix = '--p' + panelIdx;
      panel.querySelectorAll('[id]').forEach(function (el) {
        el.id = el.id + suffix;
      });
      panel.querySelectorAll('[for]').forEach(function (el) {
        el.setAttribute('for', el.getAttribute('for') + suffix);
      });
      panel.querySelectorAll('[aria-controls]').forEach(function (el) {
        el.setAttribute('aria-controls', el.getAttribute('aria-controls') + suffix);
      });
    });

    function activateFilterPanel(idx) {
      filterPanels.forEach(function (panel, i) {
        var match = i === idx;
        panel.classList.toggle('is-active', match);
        if (match) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    var tabs = Array.prototype.slice.call(tabBar.querySelectorAll('.shop-grid__tab'));
    var panels = Array.prototype.slice.call(panelsContainer.querySelectorAll('.shop-grid__panel'));
    if (!tabs.length || !panels.length) return;

    // Bind pagination to every panel up front
    panels.forEach(function (panel) {
      bindPagination(panel);
      paginatePanel(panel, 1);
    });

    // Initial: count from the active panel + fire animations on its products
    var initialPanel = getActivePanel(panels);
    updateCount(countEl, initialPanel);
    pruneForActiveTab(sidebar, panels);
    if (initialPanel) {
      requestAnimationFrame(function () {
        triggerAosOn(initialPanel);
      });
    }

    function activate(targetIndex, options) {
      options = options || {};
      var current = -1;
      tabs.forEach(function (t, i) { if (t.classList.contains('is-active')) current = i; });
      if (current === targetIndex) return;

      tabs.forEach(function (tab, i) {
        var isActive = i === targetIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      var currentPanel = panels[current];
      var nextPanel = panels[targetIndex];
      if (!nextPanel) return;

      var swap = function () {
        if (currentPanel) {
          currentPanel.classList.remove('is-active', 'is-leaving');
          currentPanel.setAttribute('hidden', '');
        }
        nextPanel.removeAttribute('hidden');
        void nextPanel.offsetWidth;
        nextPanel.classList.add('is-active');

        // Swap sidebar filter panel to match
        activateFilterPanel(targetIndex);

        // Apply the new panel's filter form state to its items (or clear if none)
        var nextItems = nextPanel.querySelectorAll('.shop-grid__product-item');
        nextItems.forEach(function (it) { it.dataset.filterHidden = 'false'; });
        nextPanel.dataset.filterApplied = '';
        // Prune available filter options to those that exist in this tab
        pruneForActiveTab(sidebar, panels);
        applyFiltersToActivePanel(panels, countEl, sortEl);

        updateCount(countEl, nextPanel);

        // Apply current sort then re-paginate from page 1 on the new panel
        if (sortEl && sortEl.value) sortPanel(nextPanel, sortEl.value);
        paginatePanel(nextPanel, 1);

        triggerAosOn(nextPanel);
      };

      if (currentPanel) {
        currentPanel.classList.add('is-leaving');
        currentPanel.classList.remove('is-active');
        setTimeout(swap, 200);
      } else {
        swap();
      }

      if (!options.silent) {
        var label = tabs[targetIndex].querySelector('.shop-grid__tab-label');
        var slug = label ? label.textContent.trim().toLowerCase().replace(/\s+/g, '-') : String(targetIndex);
        var url = new URL(window.location.href);
        url.searchParams.set('tab', slug);
        history.replaceState({}, '', url.toString());
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        // If this click came at the tail of a drag, ignore it
        if (tabBar.classList.contains('is-dragging')) return;
        activate(i);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          activate((i + 1) % tabs.length);
          tabs[(i + 1) % tabs.length].focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = (i - 1 + tabs.length) % tabs.length;
          activate(prev);
          tabs[prev].focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          activate(0);
          tabs[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          activate(tabs.length - 1);
          tabs[tabs.length - 1].focus();
        }
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        var p = getActivePanel(panels);
        sortPanel(p, sortEl.value);
        paginatePanel(p, 1);
      });
    }

    // Mobile filter toggle
    var filterToggle = root.querySelector('[data-shop-grid-filter-toggle]');
    if (filterToggle && sidebar) {
      filterToggle.addEventListener('click', function () {
        var open = !sidebar.classList.contains('is-open');
        sidebar.classList.toggle('is-open', open);
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Reposition sidebar on mobile: should sit BETWEEN the products bar and the panels.
    // On desktop, it stays as a sibling of .shop-grid__main (left column).
    var sidebarHome = sidebar ? sidebar.parentNode : null;
    var sidebarPlaceholder = null;
    var mainEl = root.querySelector('.shop-grid__main');
    var barEl = root.querySelector('.shop-grid__bar');
    function positionSidebarForViewport() {
      if (!sidebar || !mainEl || !barEl) return;
      var isMobile = window.matchMedia('(max-width: 990px)').matches;
      if (isMobile) {
        if (sidebar.parentNode !== mainEl) {
          if (!sidebarPlaceholder) {
            sidebarPlaceholder = document.createComment(' sidebar-home ');
            sidebarHome.insertBefore(sidebarPlaceholder, sidebar);
          }
          // Insert right after the bar
          barEl.insertAdjacentElement('afterend', sidebar);
        }
      } else {
        if (sidebar.parentNode === mainEl && sidebarPlaceholder && sidebarPlaceholder.parentNode) {
          sidebarPlaceholder.parentNode.insertBefore(sidebar, sidebarPlaceholder);
          // Also close it so it doesn't stay open on resize-up
          sidebar.classList.remove('is-open');
          if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
        }
      }
    }
    positionSidebarForViewport();
    window.addEventListener('resize', function () {
      clearTimeout(window._shopGridResizeTimer);
      window._shopGridResizeTimer = setTimeout(positionSidebarForViewport, 150);
    });

    if (sidebar) {
      // Bind "Show more / Show less" toggle on filter sections
      sidebar.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-show-more-trigger]');
        if (trigger && sidebar.contains(trigger)) {
          e.preventDefault();
          var expanded = trigger.classList.toggle('is-expanded');
          trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          var controlsId = trigger.getAttribute('aria-controls');
          var container = controlsId ? document.getElementById(controlsId) : trigger.previousElementSibling;
          if (container) container.classList.toggle('is-expanded', expanded);
          return;
        }
        // Collapsible filter group headings
        var collapseTrigger = e.target.closest('[data-collapsible-trigger]:not([data-show-more-trigger])');
        if (collapseTrigger && sidebar.contains(collapseTrigger)) {
          e.preventDefault();
          var open = collapseTrigger.getAttribute('aria-expanded') !== 'true';
          collapseTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          collapseTrigger.classList.toggle('is-expanded', open);
          var cid = collapseTrigger.getAttribute('aria-controls');
          var cContainer = cid ? document.getElementById(cid) : null;
          if (cContainer) {
            // Always keep in DOM; CSS handles visual collapse via max-height/opacity/visibility transitions.
            cContainer.removeAttribute('hidden');
            cContainer.classList.toggle('is-expanded', open);
          }
        }
      });

      var debounceTimer = null;
      var bar = root.querySelector('.shop-grid__bar');
      var scrollToBar = function () {
        if (!bar) return;
        var headerEl = document.querySelector('[data-header-sticky]') || document.querySelector('.header-group');
        var headerH = headerEl ? headerEl.getBoundingClientRect().height : 0;
        var top = bar.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
        if (top < 0) top = 0;
        window.scrollTo({ top: top, behavior: 'smooth' });
        // Also reset the sidebar's internal scroll to the top
        if (sidebar && typeof sidebar.scrollTo === 'function') {
          sidebar.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (sidebar) {
          sidebar.scrollTop = 0;
        }
      };
      var triggerFilter = function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          applyFiltersToActivePanel(panels, countEl, sortEl);
          scrollToBar();
        }, 80);
      };
      sidebar.addEventListener('change', function (e) {
        if (e.target.closest('.shop-grid__filter-form')) triggerFilter();
      });
      sidebar.addEventListener('input', function (e) {
        var t = e.target;
        if (!t.closest('.shop-grid__filter-form')) return;
        if (t.type === 'range' || t.type === 'number' || t.type === 'text') triggerFilter();
      });
      sidebar.addEventListener('submit', function (e) {
        if (e.target.classList && e.target.classList.contains('shop-grid__filter-form')) {
          e.preventDefault();
          triggerFilter();
        }
      });
      sidebar.addEventListener('click', function (e) {
        var clear = e.target.closest('[data-filter-reset], .collection__remove-filter-link, a[href*="?filter."], a[href*="&filter."]');
        if (clear && clear.closest('.shop-grid__filter-form')) {
          e.preventDefault();
          var form = clear.closest('.shop-grid__filter-form');
          if (form) {
            var inputs = form.querySelectorAll('input, select');
            inputs.forEach(function (inp) {
              if (inp.type === 'checkbox' || inp.type === 'radio') inp.checked = false;
              else if (inp.type === 'range' || inp.type === 'number') inp.value = inp.defaultValue || '';
              else inp.value = '';
            });
          }
          triggerFilter();
        }
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-section-type="shop-grid"]');
    roots.forEach(initShopGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="shop-grid"]');
    if (section) initShopGrid(section);
  });
})();
